import { Auth } from 'aws-amplify';
import { isPassportProfile, getRuntimeConfig } from '../../app-config';

if (isPassportProfile()) {
  try {
    const { userPoolWebClientId, userPoolId, endpoint, aws_region } = getRuntimeConfig();

    Auth.configure({
      Auth: {
        userPoolWebClientId,
        userPoolId,
        endpoint,
        aws_region
      }
    });

  } catch (e) {
    throw new Error(e);
  }
}
